/**
 * The IVR folder an audio URL points into, or '' if the URL is absent or has no folder segment.
 * Nothing persists the folder, so the URLs are the only record of which one was provisioned.
 */
export const extractFolder = (url: string | null | undefined): string => {
  if (!url) return '';
  try {
    const segments = new URL(url).pathname.split('/').filter(Boolean);
    return segments.length >= 2 ? segments[0] : '';
  } catch {
    return '';
  }
};

/** The folder from the first URL that has one — campaigns do not always have all three. */
export const ivrFolderFromUrls = (...urls: (string | null | undefined)[]): string =>
  urls.map(extractFolder).find(Boolean) ?? '';
